import React, { Component } from 'react'
import { Menu } from './menu';
import Mobilemenu from './Mobile_menu';

export class Header extends Component {
    state = {
        show: false,
      }    
    toggle = () => this.setState((currentState) => ({show: !currentState.show}));
    render() {  
        return (
                <header id="masthead" className="header ttm-header-style-01">
                    {/* ttm-header-wrap */}
                    <div className="ttm-header-wrap">
                        <div id="navbar" className="ttm-stickable-header clearfix">
                            <div className="site-header-menu">
                                <div className="container">
                                    {/* site-branding */}
                                    <div className="site-branding">
                                    <h1>
                                        <a className="home-link" href={process.env.PUBLIC_URL + '/'} title="Altech" rel="home">
                                            <img id="logo-img" className="img-fluid" alt="logo" src="images/logo.svg" />
                                        </a>
                                    </h1>
                                    </div>
                                    {/* site-branding end*/}
                                    {/*site-navigation */}
                                    <div className="site-navigation">
                                        <div className="ttm-right-header">
                                            <div class="side-menu-container d-flex align-items-center">
                                                <div class="header_call">
                                                    <span class="call-text position-relative ttm-textcolor-white">Tollfree : </span>
                                                    <a href="tel:1234567890" class="call_btn ttm-textcolor-white"> (+123 456 7890)</a>
                                                </div>
                                            </div>
                                        </div>
                                        <Menu />
                                        <div className="mobilemenu"><Mobilemenu/></div>
                                    </div>
                                    {/*site-navigation end*/}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ttm-header-wrap end*/}
                </header>               
        )
    }
}

export default Header;